import Button from '@atlaskit/button/new';
import Spinner from '@atlaskit/spinner';
import { GlobalPageLoadExperience } from '@atlassian/ufo';
import { messages } from '@databases/intl/messages';
import { logError } from '@databases/logs';
import { type SerializedError } from '@databases/types';
import { deserializeError } from '@databases/utils/utils';
import React, { lazy, Suspense } from 'react';
import { useIntl } from 'react-intl-next';

import { dynamicImport } from '@canvas/dynamic-import';

import genericErrorIllustration from './assets/generic_error.svg';

const ShrinkingEmptyState = lazy(() =>
  dynamicImport(() => import('./common/components/ShrinkingEmptyState'))
);

export const DatabaseError: React.FC<{ serializedError: SerializedError }> = ({
  serializedError,
}) => {
  const intl = useIntl();
  const { formatMessage } = intl;

  const error = deserializeError(serializedError);
  const formattedError = {
    name: error.name,
    message: error.message,
    stack: error.stack,
  };
  GlobalPageLoadExperience.failure({
    metadata: { error: formattedError },
    force: true,
  });

  logError(new Error(`Couldn't load link with error: ${error}`));
  return (
    <Suspense fallback={<Spinner interactionName="load" />}>
      <ShrinkingEmptyState
        header={formatMessage(messages['embed-view.error-heading-text'])}
        description={formatMessage(messages['embed-view.error-description-text'])}
        imageUrl={genericErrorIllustration}
        primaryAction={
          <Button appearance="primary" onClick={() => globalThis.location.reload()}>
            {formatMessage(messages['embed-view.try-again-button-text'])}
          </Button>
        }
        maxImageWidth={300}
        maxImageHeight={250}
      />
    </Suspense>
  );
};
